import { useNavigate } from 'react-router-dom';
import { capitalizedWord } from '../../utils/commonUtils';
import { ListItemWrapper } from '../../components/ui/ListItemWrapper/ListItemWrapper';
import Tags from '../../components/common/Tags';
import { getFormattedDateWithComma, getHoursAndMinutes, getTimeZone } from '../../utils/dateUtils';
import { AlertDetails } from '../../API/types/Alerts';
import { IconKeys } from '../../components/common/Icon/IconKeys';

type Props = {
  title: string;
  subtitle: string | null;
  id: string;
  entity: 'vehicle' | 'driver' | 'device' | 'alert' | 'user';
  alert?: AlertDetails;
};

function SearchItem({
  title, subtitle, id, entity, alert,
}: Props): JSX.Element {
  const navigate = useNavigate();

  return (
    <ListItemWrapper
      onClick={() => {
        if (entity === 'user') {
          navigate('/management?tab=users');
        } else {
          navigate(`/${entity}s/${id}`);
        }
      }}
    >
      <Tags.Label
        label={capitalizedWord(entity)}
      />
      <Tags.ItemOverview
        avatar={undefined}
        avatarAlt={title}
        title={title}
        subtitle={subtitle as string}
        isRoundImage
      />
      {entity === 'alert' && alert && (
        <div className="tags-container">
          <Tags.LabeledIcon
            label={`${alert.driver?.firstName} ${alert.driver?.lastName}`}
            icon={IconKeys.USER}
          />
          <Tags.LabeledIcon
            label={`${getHoursAndMinutes(alert.eventDate)} (${getTimeZone(alert.eventDate)})`}
            icon={IconKeys.TIME}
            flexible
          />
          <Tags.LabeledIcon
            label={getFormattedDateWithComma(alert.eventDate)}
            icon={IconKeys.DATE}
          />
        </div>
      )}
      <Tags.ProceedToDetails />
    </ListItemWrapper>
  );
}

export default SearchItem;
